import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-17e23bff")

_pushScopeId("data-v-17e23bff")
const _hoisted_1 = { class: "contact-list" }
const _hoisted_2 = {
  key: 0,
  class: "header"
}
const _hoisted_3 = {
  key: 0,
  class: "title"
}
const _hoisted_4 = { class: "contact-list-wrap" }
const _hoisted_5 = { class: "in-call" }
const _hoisted_6 = { class: "statusTitle" }
const _hoisted_7 = {
  key: 0,
  class: "no-active"
}
const _hoisted_8 = { class: "statusTitle" }
const _hoisted_9 = { class: "footer" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")
  const _component_ContactItem = _resolveComponent("ContactItem")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.isMobileScreen)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode(_component_Button, {
            class: "back-btn",
            icon: { spriteUrl: '/image/videoconf-icons.svg', name: 'ic25-shape'},
            size: "s",
            mode: "flat",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openDrawer('settings')))
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.t('back')), 1)
            ]),
            _: 1
          }, 8, ["icon"]),
          (_ctx.isMobileScreen)
            ? (_openBlock(), _createBlock("h2", _hoisted_3, _toDisplayString(_ctx.t('buttons.users')) + " (" + _toDisplayString(_ctx.contacts.length) + ")", 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _createVNode("p", _hoisted_6, _toDisplayString(_ctx.t('userStatus.inCall')), 1),
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.inCall, (item) => {
          return (_openBlock(), _createBlock(_component_ContactItem, {
            item: item.chatUser.displayName,
            key: item.endpointId,
            userName: item.chatUser.userName,
            endpointId: item.endpointId,
            image: item.authUser.avatar,
            type: "inCall"
          }, null, 8, ["item", "userName", "endpointId", "image"]))
        }), 128))
      ]),
      (_ctx.notActive.length)
        ? (_openBlock(), _createBlock("div", _hoisted_7, [
            _createVNode("p", _hoisted_8, _toDisplayString(_ctx.t('userStatus.offline')), 1),
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.notActive, (item) => {
              return (_openBlock(), _createBlock(_component_ContactItem, {
                item: item.chatUser.displayName,
                image: item.authUser.avatar,
                type: "offline"
              }, null, 8, ["item", "image"]))
            }), 256))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_9, [
      _createVNode(_component_Button, {
        class: "copy-link-btn",
        icon: { spriteUrl: '/image/videoconf-icons.svg', name: 'ic25-add-user', color: '--sui-gray-700'},
        width: "fill-container",
        height: "48px",
        mode: "secondary",
        size: "l",
        onClick: _ctx.openPopup
      }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.t('invitePeople.invite')), 1)
        ]),
        _: 1
      }, 8, ["icon", "onClick"])
    ])
  ]))
})